// Login
export const LOGIN = "LOGIN";
export const AZURE_LOGIN = "AZURE_LOGIN";
export const AZURE_REFRESH_TOKEN = "AZURE_REFRESH_TOKEN";

// Common
export const SET_MESSAGE = "SET_MESSAGE";
export const SET_LOADER = "SET_LOADER";
export const SET_OVERLAY_LOADER = "SET_OVERLAY_LOADER";

export const SHOW_ERROR_POPUP = "SHOW_ERROR_POPUP";
export const SHOW_ALERT_POPUP = "SHOW_ALERT_POPUP";
export const SET_MINI_LOADER = "SET_MINI_LOADER";
export const SHOW_NOT_FOUND_PAGE = "SHOW_NOT_FOUND_PAGE";
export const HIDE_NOT_FOUND_PAGE = "HIDE_NOT_FOUND_PAGE";
export const GET_APP_USER_LIST = "GET_APP_USER_LIST";
export const IS_SAFARI_AUTOFILL_VISISBLE = "IS_SAFARI_AUTOFILL_VISISBLE";
export const STORE_CURRENT_LOCATION = "STORE_CURRENT_LOCATION";
export const SHOW_SUCCESS_MESSAGE = "SHOW_SUCCESS_MESSAGE";
export const SHOW_DISMISSIBLE_MESSAGE = "SHOW_DISMISSIBLE_MESSAGE";

export const GET_COUNTRY_LIST = "GET_COUNTRY_LIST";
export const GET_US_STATE_LIST = "GET_US_STATE_LIST";
export const GET_CANADA_STATE_LIST = "GET_CANADA_STATE_LIST";
// Permission Action
export const ALLOW_PERMISSION_FOR_PAGE = "ALLOW_PERMISSION_FOR_PAGE";

// Permission Ballot
export const SET_PERMISSION_DATA = "SET_PERMISSION_DATA"

//Export
export const EXPORT_BALLOTS_LIST = "EXPORT_BALLOTS_LIST";
export const EXPORT_WORKITEM_LIST = "EXPORT_WORKITEM_LIST";

//Global Search
export const SET_GLOBAL_SEARCH_TEXT = "SET_GLOBAL_SEARCH_TEXT";
export const GET_GLOBAL_SEARCH_TEXT = "GET_GLOBAL_SEARCH_TEXT";

//Advance Search
export const SET_BALLOT_ADVANCE_SEARCH = "SET_BALLOT_ADVANCE_SEARCH";

//Ballot Advance Search Form Data
export const SET_BALLOT_ADVANCE_FORM_DATA = "SET_BALLOT_ADVANCE_FORM_DATA";

//WI Advance Search Form Data
export const SET_WI_ADVANCE_FORM_DATA = "SET_WI_ADVANCE_FORM_DATA";

// Ballot List Data 
export const SET_BALLOT_LIST = "SET_BALLOT_LIST"

//Ballot details data
export const SET_BALLOT_DETAIL_TAG = "SET_BALLOT_DETAIL_TAG";
export const SET_BALLOT_DETAILS = "SET_BALLOT_DETAILS";

//Ballot Status
export const SET_SELECTED_BALLOT_STATUS = "SET_SELECTED_BALLOT_STATUS";
export const GET_SELECTED_BALLOT_STATUS = "GET_SELECTED_BALLOT_STATUS";

//Ballot Status
export const SET_QUICK_SEARCH_SELECTED_USER = "SET_QUICK_SEARCH_SELECTED_USER";
export const GET_QUICK_SEARCH_SELECTED_USER = "GET_QUICK_SEARCH_SELECTED_USER";

//Ballot Level
export const SET_QUICK_SEARCH_SELECTED_LEVEL = "SET_QUICK_SEARCH_SELECTED_LEVEL";
export const GET_QUICK_SEARCH_SELECTED_LEVEL = "GET_QUICK_SEARCH_SELECTED_LEVEL";

//IsUserOfficer
export const SET_IS_USER_OFFICER = "SET_IS_USER_OFFICER";
export const GET_IS_USER_OFFICER = "GET_IS_USER_OFFICER";

//Work Item List
export const SET_WORK_ITEM_LIST = "SET_WORK_ITEM_LIST"

//Work Item Details
export const SET_WORK_ITEM_DETAIL = "SET_WORK_ITEM_DETAIL"
export const SET_COLLAB_API_FAILED = "SET_COLLAB_API_FAILED";

//Work Item Status
export const SET_SELECTED_WORKITEM_STATUS ="SET_SELECTED_WORKITEM_STATUS";

//Work Item Type
export const SET_SELECTED_WORKITEM_TYPE ="SET_SELECTED_WORKITEM_TYPE";

//Work Item Suppressed
export const SET_WI_SUPPRESS = "SET_WI_SUPPRESS"

//Work Item Extra Fields
export const SET_WI_EXTRA_FIELDS = "SET_WI_EXTRA_FIELDS"

//Drafts List
export const SET_DRAFTS_LIST = "SET_DRAFTS_LIST"

//Ballot History List
export const SET_BALLOT_HISTORY_LIST = "SET_BALLOT_HISTORY_LIST"

export const SET_MEMBER_LIST = "SET_MEMBER_LIST";

//DTN Details
export const SET_DTN_DETAIL = "SET_DTN_DETAIL"

//NAVIGATION Details
export const SET_NAVIGATION = "SET_NAVIGATION"

// Set All committees
export const SET_ALL_COMMITTEES = "SET_ALL_COMMITTEES"

export const SET_ACTIVE_COMMITTEES = "SET_ACTIVE_COMMITTEES"

export const MANAGE_BALLOT_FLYOUT= "MANAGE_BALLOT_FLYOUT"

export const SET_BALLOT_DOCUMENT_INFO = "SET_BALLOT_DOCUMENT_INFO"

export const SET_BALLOT_TRACKING_LIST = "SET_BALLOT_TRACKING_LIST"

// Draft Actions

export const SET_SELECTED_WITN = "SET_SELECTED_WITN" 

export const SET_SHOW_ALERT_MODAL_FOR_PENDINGPUBLICATION_BALLOT = "SET_SHOW_ALERT_MODAL_FOR_PENDINGPUBLICATION_BALLOT"

// ballot Designation Data

export const SET_BALLOT_DESIGNATION = "SET_BALLOT_DESIGNATION";

// WI Quick filter
export const SET_QUICK_FILTERS = "SET_QUICK_FILTERS";

// Vote Detail
export const SET_VOTE_DETAIL = "SET_VOTE_DETAIL";
export const VOTE_DETAIL = "VOTE_DETAIL"

// Export Voter List
export const SET_EXPORT_VOTER_LIST = "SET_EXPORT_VOTER_LIST";

export const SET_NAVIGATION_STATE = "SET_NAVIGATION_STATE";

// Draft Dependency List
export const SET_DRAFT_DEPENDENCY = "SET_DRAFT_DEPENDENCY";

// Negative Comment Review
export const SET_BALLOT_ITEM_INFORMATION = "SET_BALLOT_ITEM_INFORMATION";
export const SET_NEGATIVE_RULING_RATIONALE = "SET_NEGATIVE_RULING_RATIONALE";

// ANSI Committee and Standard
export const SET_ANSI_COMMITTEE_LIST = "SET_ANSI_COMMITTEE_LIST";
export const SET_ANSI_STANDARD_LIST = "SET_ANSI_STANDARD_LIST";

export const SET_ANSI_SELECTED_COMMITTEE ="SET_ANSI_SELECTED_COMMITTEE";
export const SET_ANSI_SELECTED_STANDARD = "SET_ANSI_SELECTED_STANDARD";

export const SET_ANSI_TAB_INDEX = "SET_ANSI_TAB_INDEX";

export const SET_SELECTED_COMMITTEE = "SET_SELECTED_COMMITTEE";

export const SET_ANSI_DELETE_FLOW = "SET_ANSI_DELETE_FLOW";

//ANSI BSR108
export const SET_BSR108_DATA = "SET_BSR108_DATA";

//ANSI BSR109
export const SET_BSR109_DATA = "SET_BSR109_DATA";


//ANSI Audit Log
export const SET_ANSI_AUDIT_LOG ="SET_ANSI_AUDIT_LOG"

export const SET_PINS_REPORTS_DATA = "SET_PINS_REPORTS_DATA";

// All ANSI COMMITTEE Data
export const SET_ALL_ANSI_COMMITTEE_LIST = "SET_ALL_ANSI_COMMITTEE_LIST"

// BSR Delete
export const SET_BSR_DELETE_FLOW = "SET_BSR_DELETE_FLOW"